/**
 * @file
 * 
 * Script para generar una plantilla XLS a partir de una colección de datos. 
 * Se usa dependencia con xls para generar la plantilla y tempa-xlsx para habilitar estilos
 * 
 * Se implementa la lógica basado en la librería de react-data-export
 * 
 * @author alejjahi
 */

import XLSX from "tempa-xlsx";
import { estiloFilasXLS, LibroDocumentoXLS } from "../modelo/PlanillasXLS";

const dateToNumber = (value: any) => {
    var epoch = Date.parse(value);
    return (epoch - new Date(Date.UTC(1899, 11, 30)).valueOf()) / (24 * 60 * 60 * 1000);
};

const excelSheetFromDataSet = (dataSet: any) => {

    if (dataSet === undefined || dataSet.length === 0) {
        return {};
    }

    var ws = {};
    var range = {s: {c: 10000000, r: 10000000}, e: {c: 0, r: 0}};
    var rowCount = 0;

    dataSet.forEach((dataSetItem: any) => {
        var columns = dataSetItem.columns;
        var xSteps = typeof(dataSetItem.xSteps) === 'number' ? dataSetItem.xSteps : 0;
        var ySteps = typeof(dataSetItem.ySteps) === 'number' ? dataSetItem.ySteps : 0;
        var data = dataSetItem.data;
        if (dataSet === undefined || dataSet.length === 0) {
            return;
        }

        rowCount += ySteps;

        var columnsWidth = [];
        if (columns.length >= 0) {
            columns.forEach((col, index) => {
                var cellRef = XLSX.utils.encode_cell({c: xSteps + index, r: rowCount});
                fixRange(range, 0, 0, rowCount, xSteps, ySteps);
                var colTitle = col;
                if (typeof col === 'object'){
                    columnsWidth.push(col.width || {wpx:80});
                }
                getHeaderCell(colTitle, cellRef, ws);
            });

            rowCount += 1;
        }

        if (columnsWidth.length > 0){
            ws['!cols'] = columnsWidth;
        }

        for (var R = 0; R !== data.length; ++R, rowCount++) {
            const estiloFila = estiloFilasXLS(rowCount);
            for (var C = 0; C !== data[R].length; ++C) {
                var cellRef = XLSX.utils.encode_cell({c: C + xSteps, r: rowCount});
                fixRange(range, R, C, rowCount, xSteps, ySteps);
                getCell(data[R][C], cellRef, ws, estiloFila);
            }
        }
    });

    if (range.s.c < 10000000) {
        ws['!ref'] = XLSX.utils.encode_range(range);
    }

    return ws;
};

function getHeaderCell(v:any, cellRef:any, ws:any) {
    var cell = { v: undefined, t: undefined, s: undefined };
    var headerCellStyle = v.style ? v.style : { font: { bold: true } };
    cell.v = v.title;
    cell.t = 's';
    cell.s = headerCellStyle;
    ws[cellRef] = cell;
}

function getCell(v:any, cellRef:any, ws:any, stylerow: any) {

    var cell = { v: v, s: undefined, t: undefined, z:undefined};
    if (v === null) {
        return;
    }

    var isDate = (v instanceof Date);
    if (!isDate && (typeof v === 'object')) {
        var cellStyle = v.style ? v.style : stylerow; /* Estilo celdas */
        cell.s = cellStyle;
        cell.v = v.value;
        v = v.value;
    }

    if (typeof v === 'number') {
        cell.t = 'n';
    } else if (typeof v === 'boolean') {
        cell.t = 'b';
    } else if (isDate) {
        cell.t = 'n';
        cell.z = XLSX.SSF._table[14];
        cell.v = dateToNumber(cell.v);
    } else {
        cell.t = 's';
    }
    ws[cellRef] = cell;
}

function fixRange(range:any, R:any, C:any, rowCount:any, xSteps:any, ySteps:any ) {
    if (range.s.r > R + rowCount) {
        range.s.r = R + rowCount;
    }
    if (range.s.c > C + xSteps) {
        range.s.c = C + xSteps;
    }
    if (range.e.r < R + rowCount) {
        range.e.r = R + rowCount;
    }
    if (range.e.c < C + xSteps) {
        range.e.c = C + xSteps;
    }
}

function s2ab(s: any) {
    var buf = new ArrayBuffer(s.length);
    var view = new Uint8Array(buf);
    for (var i=0; i!==s.length; ++i) {
        view[i] = s.charCodeAt(i) & 0xFF;
    }
    return buf;
}

export const crearPlantillaXLS = (librosXLS: Array<string>, datosLibrosXLS: Array<LibroDocumentoXLS>) => {
    
    const documentoXLS = {
        SheetNames: librosXLS,
        Sheets: {},
        Props: {
            Title: "Reporte Afiliaciones Negocio ARL SURA",
            Subject: "Generado por la aplicación Gestor de Afiliaciones ARL",
            Author: "AFILINEA ARL SURA",
            CreatedDate: new Date()
        }
    };

    datosLibrosXLS.forEach((libro: LibroDocumentoXLS) => {
        const metadata = [{
            columns: libro.cabecera,
            data: libro.datos 
        }];
        documentoXLS.Sheets[libro.nombreLibro] = excelSheetFromDataSet(metadata);
    });

    var bytesXLS = XLSX.write(documentoXLS, {bookType: 'xlsx', bookSST: true, type: 'binary'});
    const documentBlob = new Blob([s2ab(bytesXLS)]);

    return documentBlob;
};


// WEBPACK FOOTER //
// ./src/co/sura/dominio/general/componentes/GenerarPlantillaXLS.ts